import { FC } from "react";
import cls from "classnames";
import styles from "./index.module.scss";
import { Root, createRoot } from "react-dom/client";
import { useAtomValue } from "jotai";

import { isWorkLeftPanelOpenAtom } from "@/atom/drawBoard";

type ToastProps = {
  className?: string;
  message: string;
};

const Toast: FC<ToastProps> = ({ message, className }) => {
  const isWorkLeftPanelOpen = useAtomValue(isWorkLeftPanelOpenAtom);
  return (
    <div
      className={cls({
        [styles.toast]: true,
        [className!]: className,
        [styles.leftOpen]: isWorkLeftPanelOpen,
      })}
    >
      {message}
    </div>
  );
};

// 存储需要卸载的队列
const unmountQueue: Set<Root> & { timer?: NodeJS.Timeout } = new Set<Root>();

/** 卸载弹窗 */
const unmountToast = () => {
  try {
    unmountQueue.forEach((root) => root.unmount());
    unmountQueue.clear();
  } catch (error) {
    // 处理卸载异常情况
    console.log("error", error);
  }

  unmountQueue.timer && clearTimeout(unmountQueue.timer);
  unmountQueue.timer = undefined;
};

/** 弹出来的toast */
const messageToast = (
  props: Partial<ToastProps>,
  duration = 2000,
  toastId = "toast"
) => {
  let container = document.getElementById(toastId);
  // 不存在则创建一个div
  if (!container) {
    container = document.createElement("div");
    container.setAttribute("id", toastId);
    document.body.appendChild(container);
  }
  // 渲染前销毁掉所有的toast
  unmountToast();
  const root = createRoot(container);
  root.render(<Toast {...(props as ToastProps)} />);
  // 把销毁函数存入队列中
  unmountQueue.add(root);

  unmountQueue.timer = setTimeout(unmountToast, duration);
  return unmountQueue.timer;
};

export const message = {
  info: (message: string, duration?: number) =>
    messageToast({ message }, duration),
  destroy: unmountToast,
};

export default Toast;
